const API_BASE =
  import.meta.env.VITE_API_BASE ||
  "https://api.suraksha24x7.com";

export const GetImageUrl = (path) => {
  if (!path) return "";

  if (path.startsWith("blob:")) return path;

  if (path.startsWith("http")) return path;

  const cleanPath = path.replace(/\\/g, "/");

  return `${API_BASE.replace(/\/$/, "")}/${cleanPath.replace(/^\//, "")}`;
};
